import {MapLayer} from './MapLayer';

export default MapLayer;